// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3-vE6","title":"AfterFrontImage_title__AcBQ5"};